export function validateDocumentUploadFile(file) {
  if (!file) return 'Seleziona un file da caricare.';
  if (file.size === 0) return 'Il file selezionato è vuoto.';
  // Leave room for multipart metadata within the backend's 10 MiB request limit.
  if (file.size > 10_000_000) return 'Il file supera il limite di 10 MB.';
  return '';
}

export function validateUploadDocumentForm({ form, uploadedFile }) {
  if (!form.name?.trim()) return 'Inserisci il titolo del documento.';
  if (!form.clientId) return 'Seleziona almeno un cliente.';
  if (!form.uploadedBy?.trim()) return 'Seleziona il personale che gestisce il documento.';
  if (!form.category?.trim()) return 'Seleziona una categoria.';
  return validateDocumentUploadFile(uploadedFile);
}

export function validateMandateForm(form) {
  if (!form.clientId || !form.firmatario || !form.tipoCrediti || !form.dataInizio) {
    return 'Compila i campi obbligatori del mandato';
  }

  return '';
}

export function validateContractForm(form) {
  if (!form.clientId || !form.dataContratto || !form.luogoContratto || !form.firmatario) {
    return 'Compila i campi obbligatori del contratto';
  }

  return '';
}
